/* AvailablePackagesListComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./AvailablePackagesListRenderer");
const _ = require("lodash");

class AvailablePackagesListComponent extends EventEmitter {
    constructor(availablePackages) {
        super();
        this._renderer = new Renderer(this);

        this.setExpanded();
        this.setAvailablePackages(availablePackages || {});

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._availablePackages = undefined;
            this._renderer = undefined;
            resolve();
        });
        this.emit("Shutdown");
        return prom;
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/
    _validateExpanded() {
        Object.keys(this._expanded).forEach((id) => {
            if (!this._isAvailablePackageRepo(id)) {
                delete this._expanded[id];
            }
        });
    }
    _isAvailablePackageRepo(id) {
        if (_.has(this._availablePackages, id)) {
            return true;
        } else {
            return false;
        }
    }
    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    set availablePackages(aPkgs) {
        return this.setAvailablePackages(aPkgs);
    }
    setAvailablePackages(aPkgs /*,silent*/) {
        let old = _.cloneDeep(this._availablePackages);
        this._availablePackages = aPkgs;
        this.emit("AvailablePackagesReplaced", this._availablePackages, old);
        return this;
    }
    get availablePackages() {
        return this.getAvailablePackages();
    }
    getAvailablePackages() {
        return this._availablePackages;
    }
    set expanded(expandedIds) {
        return this.setExpanded(expandedIds);
    }
    setExpanded(expandedIds) {
        this._expanded = {};
        let createExpandedEntries = (id) => {
            if (this._isAvailablePackageRepo(id)) {
                this._expanded[id] = {};
            }
        };
        if (_.isObject(expandedIds)) {
            Object.keys(expandedIds).forEach(createExpandedEntries);
        } else if (_.isArray(expandedIds)) {
            expandedIds.forEach(createExpandedEntries);
        } else if (_.isString(expandedIds)) {
            createExpandedEntries(expandedIds);
        }
        return this;
    }
    get expanded() {
        return this.getExpanded();
    }
    getExpanded() {
        return this._expanded;
    }
    isExpanded(id) {
        return _.has(this._expanded, id);
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /* START PUBLIC API ACTION METHODS */
    /*******************************************/
    expand(id) {
        if (_.has(this._availablePackages, id)) {
            this._expanded[id] = {};
            this.emit("Expand", id);
        }
    }
    expandAll() {
        this.emit("ExpandAll");
    }
    collapse(id) {
        if (_.has(this._availablePackages, id)) {
            delete this._expanded[id];
            this.emit("Collapse", id);
        }
    }
    collapseAll() {
        this.emit("CollapseAll");
    }
    /*******************************************/
    /* END PUBLIC API ACTION METHODS */
    /* START PUBLIC API ACTION METHODS */
    /*******************************************/
    launchEditor(editorState, editorName, opts) {
        this.emit("LaunchEditor", editorState, editorName, opts);
    }
    /*******************************************/
    /* END PUBLIC API ACTION METHODS */
    /*******************************************/
}
module.exports = AvailablePackagesListComponent;
